import { defineStore } from "pinia";
import { loadScript } from "~/lib/script";
import type { YaPaySdk } from "~/types/yaPay";
import { useCartStore } from "./cartStore";
import { useMainStore } from "./mainState";

declare var YaPay: YaPaySdk.YaPay | undefined;

export const useYandexPayStore = defineStore('yandex-pay', () => {

    let inited = false
    let loading = false;

    const resolvers: ((v: void) => void)[] = [];

    const cartStore = useCartStore();

    const mainStore = useMainStore();

    const isSplitActive = computed(() => mainStore.location?.payTypes.some((el) => el.id === 24) ?? false);

    function loadYandexScript() {
        if (!inited) {

            if (!loading) {
                loading = true;
                loadScript('https://pay.yandex.ru/sdk/v1/pay.js')
                    .then(() => {
                        inited = true;
                        resolvers.forEach((el) => el());
                    });
            }

            return new Promise<void>((resolve) => {
                resolvers.push(resolve);
            });
        }

        return new Promise<void>((resolve) => {
            resolve();
        });
    }

    async function onPayButtonClick() {

    }

    function onFormError(reason: string) {
        console.error(`Payment error — ${reason}`);
    }

    async function makeSession(money: number) {
        if (!YaPay) {
            return null;
        }

        return await YaPay.createSession({
            availablePaymentMethods: ['SPLIT'],
            env: 'PRODUCTION',
            currencyCode: 'RUB',
            merchantId: '8480cbf0-58df-4fe3-8b17-9cb8b9f9cb26',
            totalAmount: money.toFixed(2),
            version: 4
        }, {
            onFormOpenError: onFormError,
            onPayButtonClick: onPayButtonClick
        });
    }

    async function createSession(money: number) {
        if (!inited) {
            await loadYandexScript();
        }

        return makeSession(money);
    }

    let paymentSession: YaPaySdk.PaymentSession | null = null;

    async function getCartPaymentSession() {

        if (!inited) {
            await loadYandexScript();
        }

        if (!paymentSession) {
            paymentSession = await makeSession(cartStore.itemsPrice);
        }

        return paymentSession;
    }

    function updateCartPaymentSession() {
        if (!paymentSession) {
            return;
        }

        paymentSession.update(() => {
            return {totalAmount: cartStore.itemsPrice}
        })
    }

    return { loadYandexScript, isSplitActive, getCartPaymentSession, updateCartPaymentSession, createSession };
});
